import { ErrorMessage, Field, useFormikContext } from "formik";
import React, { ChangeEvent, useEffect, useState } from "react";
import InputError from "../input-error/input-error";

const GlimpseInputBox = (props: any) => {
  const {
    label,
    name,
    id,
    type,
    maxLength,
    showCount,
    isPassword,
    disabled,
    sanitized,
    onBlur,
    isPercentage,
    ...rest
  } = props;

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const [errorMessage, setErrorMessage] = useState<string>("");

  const { values, setFieldValue } = useFormikContext<any>();
  const [charCount, setCharCount] = useState<number>(
    typeof values[name] === "string" ? values[name].length : 0
  );

  useEffect(() => {
    const currentValue = values[name];
    if (typeof currentValue === "string") {
      setCharCount(currentValue.length);
    }
  }, [values[name]]);

  // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const { value } = e.target;

  //   if (maxLength && typeof value === "string" && value.length <= maxLength) {
  //     setCharCount(value.length);
  //     setFieldValue(name, value);
  //   }
  // };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (typeof value === "string") {
      if (sanitized) {
        let newValue = value.replace(/\s/g, "");
        if (newValue.length <= maxLength) {
          setCharCount(newValue.length);
          setFieldValue(name, newValue.trim());
          setErrorMessage("");
        } else {
          setErrorMessage(`Maximum character limit of ${maxLength} exceeded.`);
        }
      } else {
        if (value.length <= maxLength) {
          setCharCount(value.length);
          setFieldValue(name, value);
          setErrorMessage("");
        } else {
          setErrorMessage(`Maximum character limit of ${maxLength} exceeded.`);
        }
      }
    }
  };
  return (
    <>
      <label
        htmlFor={name}
        className="block text-sm font-[500] leading-4 text-gray-900"
      >
        {label}
      </label>
      <div className="flex felx-row items-center">
      <Field
        name={name}
        id={id}
        as={type}
        type={showPassword ? "text" : type}
        onChange={handleChange}
        autoComplete="off"
        disabled={disabled}
        className={`block w-full h-[40px] p-3 mt-1 text-gray-900 border shadow-sm rounded-xl border-input_outline placeholder:text-headerBlack sm:text-sm sm:leading-6 text-headerBlack focus:ring-0 focus:border-input_outline focus:outline-0 ${
          disabled && "bg-horizontalRow"
        } ${errorMessage && "border border-red"}`}
        {...rest}
      />
     {isPercentage&&   <label
        className="block ml-1 text-md font-[800] "
      >
      %
      </label>}
      </div>
 
     
      {showCount && (
        <span className="text-[16px] text-horizontalRow text-end relative left-[85%] bottom-[30px]">
          {charCount}/{maxLength}
        </span>
      )}
      {errorMessage && (
        <span className="flex text-xs text-red text-start">{errorMessage}</span>
      )}
      {isPassword && (
        <span
          className={`relative left-[85%] bottom-[30px] ${
            errorMessage && "bottom-[45px]"
          }`}
        >
          <button type="button" onClick={togglePasswordVisibility}>
            {showPassword ? (
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.0998 10.3L13.6498 8.84998C13.7998 8.06664 13.5748 7.33331 12.9748 6.64998C12.3748 5.96664 11.5998 5.69998 10.6498 5.84998L9.1998 4.39998C9.48314 4.26664 9.77047 4.16664 10.0618 4.09998C10.3538 4.03331 10.6665 3.99998 10.9998 3.99998C12.2498 3.99998 13.3125 4.43731 14.1878 5.31198C15.0625 6.18731 15.4998 7.24998 15.4998 8.49998C15.4998 8.83331 15.4665 9.14598 15.3998 9.43797C15.3331 9.72931 15.2331 10.0166 15.0998 10.3ZM18.2998 13.45L16.8498 12.05C17.4831 11.5666 18.0458 11.0373 18.5378 10.462C19.0291 9.88731 19.4498 9.23331 19.7998 8.49998C18.9665 6.81664 17.7705 5.47898 16.2118 4.48698C14.6538 3.49564 12.9165 2.99998 10.9998 2.99998C10.5165 2.99998 10.0415 3.03331 9.5748 3.09998C9.10814 3.16664 8.6498 3.26664 8.1998 3.39998L6.64981 1.84998C7.33314 1.56664 8.03314 1.35398 8.7498 1.21198C9.46647 1.07064 10.2165 0.999976 10.9998 0.999976C13.3831 0.999976 15.5248 1.62898 17.4248 2.88698C19.3248 4.14564 20.7498 5.78331 21.6998 7.79998C21.7498 7.88331 21.7831 7.98731 21.7998 8.11198C21.8165 8.23731 21.8248 8.36664 21.8248 8.49998C21.8248 8.63331 21.8125 8.76231 21.7878 8.88698C21.7625 9.01231 21.7331 9.11664 21.6998 9.19998C21.3165 10.05 20.8375 10.8333 20.2628 11.55C19.6875 12.2666 19.0331 12.9 18.2998 13.45ZM18.0998 18.9L14.5998 15.45C14.0165 15.6333 13.4291 15.771 12.8378 15.863C12.2458 15.9543 11.6331 16 10.9998 16C8.61647 16 6.4748 15.371 4.5748 14.113C2.6748 12.8543 1.2498 11.2166 0.299805 9.19998C0.249805 9.11664 0.216471 9.01231 0.199805 8.88698C0.183138 8.76231 0.174805 8.63331 0.174805 8.49998C0.174805 8.36664 0.183138 8.24164 0.199805 8.12498C0.216471 8.00831 0.249805 7.90831 0.299805 7.82498C0.649805 7.07498 1.06647 6.38331 1.5498 5.74998C2.03314 5.11664 2.56647 4.53331 3.1498 3.99998L1.0748 1.89998C0.891471 1.71664 0.799805 1.48731 0.799805 1.21198C0.799805 0.937309 0.899805 0.699976 1.0998 0.499976C1.28314 0.316642 1.51647 0.224976 1.7998 0.224976C2.08314 0.224976 2.31647 0.316642 2.4998 0.499976L19.4998 17.5C19.6831 17.6833 19.7791 17.9126 19.7878 18.188C19.7958 18.4626 19.6998 18.7 19.4998 18.9C19.3165 19.0833 19.0831 19.175 18.7998 19.175C18.5165 19.175 18.2831 19.0833 18.0998 18.9ZM4.5498 5.39998C4.06647 5.83331 3.6248 6.30831 3.2248 6.82498C2.8248 7.34164 2.48314 7.89998 2.1998 8.49998C3.03314 10.1833 4.22881 11.5206 5.78681 12.512C7.34547 13.504 9.08314 14 10.9998 14C11.3331 14 11.6581 13.9793 11.9748 13.938C12.2915 13.896 12.6165 13.85 12.9498 13.8L12.0498 12.85C11.8665 12.9 11.6915 12.9373 11.5248 12.962C11.3581 12.9873 11.1831 13 10.9998 13C9.7498 13 8.68714 12.5626 7.8118 11.688C6.93714 10.8126 6.4998 9.74998 6.4998 8.49998C6.4998 8.31664 6.51214 8.14164 6.53681 7.97498C6.56214 7.80831 6.5998 7.63331 6.64981 7.44998L4.5498 5.39998Z"
                  fill="#414346"
                />
              </svg>
            ) : (
              <svg
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12"
                  stroke="#000000"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1 12C1 12 5 20 12 20C19 20 23 12 23 12"
                  stroke="#000000"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle
                  cx={12}
                  cy={12}
                  r={3}
                  stroke="#000000"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </button>
        </span>
      )}
      <span className={`${isPassword && " relative -top-[25px]"}`}>
        <ErrorMessage name={name} component={InputError} />
      </span>
    </>
  );
};

export default GlimpseInputBox;
